module.exports = __webpack_public_path__ + "static/img/img-features-feature-2-game-7@3x.c28451a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-2-game-7@3x.png
// module id = fe+d
// module chunks = 18